import {Merchant} from '../models/restaurant.model';
import {ImageConfig} from '../enums/merchant.enum';

export const dataToMerchantInfo = (data: any, merchantId: string): Merchant => {
  return new Merchant(
    merchantId,
    data.merchant_name,
    data.merchant_email,
    data.merchant_header_title,
    data.merchant_header_text,
    data.available,
    data.merchant_banner,
    data.merchant_logo,
    data.show_locations_map,
    data.miles_away_threshold,
    data.location_image_type ? data.location_image_type : ImageConfig.default,
    data.location_image_url,
    data.category_filter_enabled,
    data.vanity_link,
    data.use_flavor_shifts_time
  );
};
